// extracted by mini-css-extract-plugin
export var closeButton = "_3y-3";
export var header = "_3y-0";
export var link = "_3y-1";
export var retryButton = "_3y-2";